<template lang="pug">
  section
    .hero.is-light
      .hero-body
        h1.title.is-5
          span.icon
            i.fas.fa-receipt.fa-sm.fa-fw
          span
            | 受注レコード管理

      <!--| 新規作成-->

    section.section
      .field.is-grouped
        .control
          button(class="button is-danger" @click="openNew")
            b-icon(pack="fas" custom-class="fa-sm fa-plus")
            span
              | 配本注文作成
        .control
          button(class="button is-danger" @click="openBooks")
            b-icon(pack="fas" custom-class="fa-sm fa-plus")
            span
              | 書籍毎に配本する
        .control
          button(class="button is-info" @click="isComponentModalActive = true")
            b-icon(pack="fas" custom-class="fa-sm fa-search")
            span
              | 絞り込む

        .control
          button(class="button is-dark" @click="exportCSV" id="first-csv-export")
            b-icon(pack="fas" custom-class="fa-sm fa-file-export")
            span
              | CSVエクスポート
        .control
          button(class="button is-dark" @click="openEdit")
            b-icon(pack="fas" custom-class="fa-sm fa-file-import")
            span
              | 更新CSVインポート

      b-modal(:active.sync="isComponentModalActive" has-modal-card)
        search-modal-form(:formProps.sync="formProps" v-on:on-search="onSearch")

      .scroll-table
        b-table(
            :data="data"
            :loading="loading"
            paginated
            narrowed
            hoverable
            striped
            icon-pack="fa"
            backend-pagination
            :total="total"
            :current-page="page"
            :per-page="perPage"
            @page-change="onPageChange"
            backend-sorting
            :default-sort-direction="defaultSortOrder"
            :default-sort="[sortField, sortOrder]"
            @sort="onSort"
            @click="onClick"
            detailed
            detail-key="id"
            id="books_table"
            )
          template(slot-scope="props")
            b-table-column(field="id" label="ID" width="40" sortable numeric)
              | {{ props.row.id }}
            b-table-column(field="isbn" label="書籍名：ISBN" width="400")
              b-tag(v-show="showStatus(props.row.book_stock_status)" type="is-info" class="shinkan-tag") {{ props.row.book_stock_status }}
              | {{ bookNameWithIsbn(props.row.isbn) }}
            b-table-column(field="agency_shop_code" label="取次書店コード" width="120")
              | {{ props.row.agency_shop_code }}
            b-table-column(field="shop_name" label="書店名" width="200")
              | {{ shopName(props.row.agency_code, props.row.agency_shop_code, props.row.book_shop_name) }}
            b-table-column(field="shop_code" label="共有書店コード" width="120")
              | {{ props.row.shop_code }}
            b-table-column(field="bansen" label="番線" width="80")
              | {{ props.row.bansen }}
            b-table-column(field="ranking" label="ランキング" width="80")
              | {{ props.row.book_shop_ranking }}
            b-table-column(field="group_name" label="グループ名" width="120")
              | {{ props.row.group_name }}
            b-table-column(field="agency_code" label="帳合" width="80")
              | {{ agencyName(props.row.agency_code) }}
            b-table-column(field="order_route_id" label="受注経路" width="100")
              | {{ orderRouteName(props.row.order_route_id) }}
            b-table-column(field="delivery_type_id" label="出荷属性" width="140")
              b-select(
                v-model="props.row.deliver_type_id"
                @input="submit(props.row)"
              )
                option(
                  v-for="deliver_type in deliver_types"
                  :value="deliver_type.id"
                  :key="deliver_type.id"
                )
                  | {{ deliverTypeName(deliver_type.id) }}
            b-table-column(field="sales_person_id" label="営業担当" width="80")
              | {{ salesPersonName(props.row.sales_person_id) }}
            b-table-column(field="kyakutyu_memo" label="客注メモ" width="200")
              b-input(
                v-model="props.row.kyakutyu_memo"
                data-vv-as="客注メモ"
                @blur="submit(props.row)"
              )
            b-table-column(field="bibo" label="備忘" width="200")
              b-input(
                v-model="props.row.bibo"
                data-vv-as="備忘"
                @blur="submit(props.row)"
              )
            b-table-column(field="accepting_date" label="受注日" width="100")
              | {{ props.row.accepting_date | moment("YYYY/MM/DD") }}
            b-table-column(field="user_name" label="登録者" width="100")
              | {{ props.row.user_name }}
            b-table-column(field="order_number" label="発注数" width="80")
              ValidationProvider(
                :rules="`required|min_value:${props.row.manipulated_number}`"
                v-slot="{ errors }"
                name="発注数"
                ref="order_number"
              )
                b-field(:type="{'is-danger': errors.length > 0 }"
                      :message="errors[0]")
                  b-input(
                    :data-vv-name="'order_number' + props.row.i"
                    data-vv-as="発注数"
                    type="number"
                    size="is-small"
                    v-model="props.row.order_number"
                    @blur="submit(props.row)"
                  )
            b-table-column(field="manipulated_number" label="配本済み数" width="80")
              | {{ props.row.manipulated_number }}
            b-table-column(field="manipulated_number" label="残数" width="80")
              | {{ props.row.order_number - props.row.manipulated_number }}
          template(slot="detail" slot-scope="props")
            .level.toggle-table
              .level-left
                .level-item
                  b-table(:data="props.row.manipulated_order_items")
                    template(slot-scope="detail_props")
                      b-table-column(field="id" label="配本レコID" numeric)
                        | {{ detail_props.row.id }}
                      b-table-column(field="order_number" label="配本数" numeric)
                        | {{ detail_props.row.order_number }}
                      b-table-column(field="manipulated_order_id" label="配本管理ID")
                        a.button.is-rounded.is-info.is-small(:href="manipulatedOrderUrl(detail_props.row.manipulated_order_id)")
                          | {{ detail_props.row.manipulated_order_sid }}
              .level-right

      button(class="button is-dark" @click="exportCSV")
        b-icon(pack="fas" custom-class="fa-sm fa-file-export")
        span
          | CSVエクスポート
</template>

<script>
  import SearchModalForm from './search_modal_form'
  import AcceptingOrderItem from 'models/accepting_order_item'
  import CacheDispatcher from 'mixins/cache_dispatcher'
  import { ValidationProvider } from 'vee-validate'

  export default {
    name: 'accepting-order-items-table',
    components: { SearchModalForm, ValidationProvider },
    mixins: [CacheDispatcher],
    data() {
      return {
        data: [],
        total: 0,
        loading: false,
        sortField: 'vote_count',
        sortOrder: 'desc',
        defaultSortOrder: 'desc',
        page: 1,
        perPage: 50,
        isComponentModalActive: false,
        formProps: {
          accepting_order_accepting_date_gteq: this.$moment().add(-30, 'days').toDate(),
          accepting_order_accepting_date_lteq: this.$moment().toDate(),
          only_uncompleted: true,
        },
        default_params: null
      }
    },
    computed: {
      books(){  return this.$store.getters['Books/records'] },
      accepting_order_routes(){ return this.$store.getters['AcceptingOrderRoutes/records'] },
      agencies(){ return this.$store.getters['Agencies/records'] },
      final_book_shop_agencies(){ return this.$store.getters['FinalBookShopAgencies/records'] },
      final_book_shops(){ return this.$store.getters['FinalBookShops/records'] },
      shop_people(){ return this.$store.getters['ShopPeople/records'] },
      deliver_types(){ return this.$store.getters['DeliverTypes/records'] },
      sales_people(){ return this.$store.getters['SalesPeople/records'] },
    },
    methods: {
      openNew(){
        window.location.href = `/users/multiple_manipulated_orders/new`
      },
      openBooks(){
        window.location.href = `/users/accepting_order_items/books`
      },
      openEdit() {
        window.location.href = '/users/multiple_accepting_order_items/edit'
      },
      bookName(value) {
        if (!value) return ''
        let a = this.books.filter(book => book.isbn == value)
        return a.length > 0 ? a[0].name : ''
      },
      bookNameWithIsbn(value){
        if (!value) return ''
        let a = this.books.filter(book => book.isbn == value)
        return a.length > 0 ? `${a[0].name}: ${a[0].isbn}` : ''
      },
      shopName(agency_code, agency_shop_code, book_shop_name){
        if(book_shop_name) return book_shop_name
        if (!agency_code) return ''
        let tmp = this.final_book_shop_agencies
            .filter(final_book_shop_agency => final_book_shop_agency.agency_code == agency_code && final_book_shop_agency.agency_shop_code == agency_shop_code)
        return tmp.length > 0 ? tmp[0].name : ''
      },
      agencyName(agency_code){
        if (!agency_code) return ''
        let tmp = this.agencies
            .filter(agency => agency.code == agency_code)
        if(tmp.length == 0)
          return ''
        return tmp[0].name
      },
      orderRouteName(id){
        if (!id) return ''
        let tmp = this.accepting_order_routes
            .filter(route => route.id == id)
        if(tmp.length == 0)
          return ''
        return tmp[0].name
      },
      deliverTypeName(id){
        if (!id) return ''
        let tmp = this.deliver_types
            .filter(type => type.id == id)
        if(tmp.length == 0)
          return ''
        return tmp[0].name
      },
      salesPersonName(id){
        if (!id) return ''
        let tmp = this.sales_people
            .filter(type => type.id == id)
        if(tmp.length == 0)
          return ''
        return tmp[0].name
      },
      exportCSV(){
        this.loading = true
        const params = this.createParams("1", 99999)
        this.$http.get(`/api/v1/accepting_order_items${params}`)
            .then(({data}) => {
              var allData = []
              data.accepting_order_items.forEach((item) => {
                let a = new AcceptingOrderItem(item)
                allData.push(Object.assign({}, a))
              })
              this.loading = false
              var csv = '\ufeff' + 'ID,共有書店コード,帳合,番線,取次書店コード,グループ名,ランキング,書店名,ISBN13,書名,客注メモ,受注経路,出荷属性,営業担当者,備忘,受注日,登録者,注文数,未配本数,配本数\n'
              allData.forEach(el => {
                var mihai = el['order_number'] - el['manipulated_number']
                csv += [
                  el['id'],
                  el['shop_code'],
                  this.agencyName(el['agency_code']),
                  el['bansen'],
                  el['agency_shop_code'],
                  el['group_name'],
                  el['book_shop_ranking'],
                  this.shopName(el['agency_code'], el['agency_shop_code'], el['book_shop_name']),
                  el['isbn'],
                  this.bookName(el['isbn']),
                  el['kyakutyu_memo'],
                  this.orderRouteName(el['order_route_id']),
                  this.deliverTypeName(el['deliver_type_id']),
                  this.salesPersonName(el['sales_person_id']),
                  el['bibo'],
                  this.$moment(el['accepting_date']).format("YYYY/MM/DD"),
                  el['user_name'],
                  el['order_number'],
                  mihai,
                  '0'
                ].join(',') + '\n'
              })
              let blob = new Blob([csv], { type: 'text/csv' })
              let link = document.createElement('a')
              link.href = window.URL.createObjectURL(blob)
              link.download = 'Result.csv'
              link.click()
            })
            .catch((error) => {
              this.loading = false
              throw error
            })
      },
      loadAsyncData() {
        const params = this.createParams(this.page, this.perPage)
        this.loading = true
        this.$http.get(`/api/v1/accepting_order_items${params}`)
            .then(({data}) => {
              this.data = []
              let currentTotal = data.total_results
              if (data.total_results / this.perPage > 1000) {
                currentTotal = this.perPage * 1000
              }
              this.total = currentTotal
              data.accepting_order_items.forEach((item) => {
                let a = new AcceptingOrderItem(item)
                this.data.push(Object.assign({}, a))
              })
              this.loading = false
              if(this.default_params != params)
                history.pushState(null, null, `/users/accepting_order_items${params}`)
              else
                history.pushState(null, null, `/users/accepting_order_items`)
            })
            .catch((error) => {
              this.data = []
              this.total = 0
              this.loading = false
              throw error
            })
      },
      createParams(page, perPage) {
        return(
          '?' + [
            `page=${page}`,
            `per_page=${perPage}`,
            Object.keys(this.formProps).map((key) => {
              if(key == "accepting_order_accepting_date_gteq"){
                return `q[${key}]=${this.$moment(this.formProps[key]).format('YYYY-MM-DD 00:00:00')}`
              } else if(key == "accepting_order_accepting_date_lteq") {
                return `q[${key}]=${this.$moment(this.formProps[key]).format('YYYY-MM-DD 23:59:59')}`
              }else {
                return `q[${key}]=${this.formProps[key]}`
              }
            }).join('&')
          ].join('&')
        )
      },
      onSearch(){
        this.onPageChange(1)
      },
      /*
       * Handle page-change event
       */
      onPageChange(page) {
        this.page = page
        this.loadAsyncData()
      },
      /*
       * Handle sort event
       */
      onSort(field, order) {
        this.page = 1
        this.sortField = field
        this.sortOrder = order
        this.formProps.s = `${this.sortField} ${this.sortOrder}`
        this.loadAsyncData()
      },
      onClick(row){
        // window.location.href = `/users/accepting_orders/${row.id}/edit`
      },
      showStatus(book_stock_status) {
        if(book_stock_status == '在庫あり') return false
        return true
      },
      submitRequest(accepting_order_item){
        var method = 'put'
        var url = `/api/v1/accepting_order_items/${accepting_order_item.id}.json`
        var params = {
          accepting_order_item: accepting_order_item
        }
        return this.$http({ method: method, url: url, data: params })
      },
      submit(accepting_order_item) {
        if(this.has_errors()) {
          this.openToast('入力内容に誤りがあります。ご確認ください。')
          return false
        }
        this.loading = true
        this.submitRequest(accepting_order_item).then(({result}) => {
          this.loading = false
          this.openToast('更新に成功しました。')
        })
        .catch((error) => {
          this.loading = false
          this.openToast('更新に失敗しました。')
          throw error
        })
      },
      has_errors() { return document.querySelector("input.is-danger") },
      openToast(message) {
        this.$toast.open({
          message: message,
          type: 'is-danger',
          position: 'is-bottom'
        })
      },
      manipulatedOrderUrl(manipulated_order_id) {
        return `/users/manipulated_orders/${manipulated_order_id}`
      }
    },
    created() {
      this.default_params = '? ' + [
        `page=${this.page}`,
        Object.keys(this.formProps).map((key) => {
          if(key == "accepting_order_accepting_date_gteq" || key == "accepting_order_accepting_date_lteq"){
            return `q[${key}]=${this.$moment(this.formProps[key]).format('YYYY-MM-DD')}`
          }else {
            return `q[${key}]=${this.formProps[key]}`
          }
        }).join('&')
      ].join('&')
      this.dispatch_with_cache('Agencies/fetch', 'agencies', this.agencies)
      // this.$store.dispatch('FinalBookShopAgencies/fetch', [ 'final_book_shop_agencies', null, { query: 'mode=simple' }])
      // this.$store.dispatch('FinalBookShops/fetch', [ 'final_book_shops', null, { query: 'mode=simple' }])
      this.$store.dispatch('Books/fetch', 'books')
      this.dispatch_with_cache('AcceptingOrderRoutes/fetch', 'accepting_order_routes', this.accepting_order_routes)
      this.$store.dispatch('DeliverTypes/fetch', 'deliver_types')
      this.dispatch_with_cache('SalesPeople/fetch', 'sales_people', this.sales_people)
      AcceptingOrderItem.initialize({
        agencies: this.agencies,
        final_book_shop_agencies: this.final_book_shop_agencies,
        books: this.books,
        accepting_order_routes: this.accepting_order_routes,
        deliver_types: this.deliver_types,
        sales_people: this.sales_people
      })
    },
    mounted() {
      let queries = this.$qs.parse(location.search.slice(1))
      if(queries) {
        let q = queries.q
        if(q) {
          Object.keys(this.formProps).forEach((key) => {
                if (q[key]) {
                  if(key == "accepting_order_accepting_date_gteq" || key == "accepting_order_accepting_date_lteq"){
                    this.formProps[key] = this.formProps[key]
                  }else{
                    this.formProps[key] = `${q[key]}`
                  }
                }
              }
          )
        }
        if (queries.page)
          this.page = parseInt(queries.page)
      }
      this.loadAsyncData()
    }
  }
</script>
